import { useState } from 'react'
import { TabWrapper, Wrapper } from './Styled'
import Page0 from './components/page0'
import Tabs from 'component/Tabs'
import { TabsType } from 'component/Tabs/Styled'
import PageLapis0 from './components/playground-lapis0'
import PageFrost0 from './components/playground-frost0'

const tabOptions = [
  {
    id: '0',
    name: 'Page 0',
  },
  {
    id: 'l0',
    name: 'Lapis',
  },
  {
    id: 'f0',
    name: 'Frost',
  },
]
export const Test = () => {
  const [tab, setTab] = useState('0')
  return (
    <Wrapper>
      <TabWrapper>
        <Tabs
          align="left"
          type={TabsType.Underline}
          options={tabOptions}
          value={tab}
          onChange={setTab}
          style={{ flex: '0 0 auto' }}
        />
      </TabWrapper>
      {tab === '0' && <Page0 />}
      {tab === 'l0' && <PageLapis0 />}
      {tab === 'f0' && <PageFrost0 />}
    </Wrapper>
  )
}

export default Test
